import { addEventListener, isExperimentalFeatureEnabled, timeStampNow } from '@datadog/browser-core';
export function listenActionEvents(_a) {
    var onPointerDown = _a.onPointerDown, onStartEvent = _a.onStartEvent;
    var selectionEmptyAtPointerDown;
    var userActivity = {
        selection: false,
        input: false,
    };
    var clickContext;
    var listeners = [
        addEventListener(window, "pointerdown" /* POINTER_DOWN */, function (event) {
            if (isValidMouseEvent(event)) {
                selectionEmptyAtPointerDown = isSelectionEmpty();
                userActivity = {
                    selection: false,
                    input: isExperimentalFeatureEnabled('dead_click_fixes')
                        ? false
                        : // Mimics the issue that was fixed in https://github.com/DataDog/browser-sdk/pull/1968
                            // The goal is to release all dead click fixes at the same time
                            userActivity.input,
                };
                clickContext = onPointerDown(event);
            }
        }, { capture: true }),
        addEventListener(window, "selectionchange" /* SELECTION_CHANGE */, function () {
            if (!selectionEmptyAtPointerDown || !isSelectionEmpty()) {
                userActivity.selection = true;
            }
        }, { capture: true }),
        addEventListener(window, isExperimentalFeatureEnabled('dead_click_fixes') ? "pointerup" /* POINTER_UP */ : "click" /* CLICK */, function (startEvent) {
            if (isValidMouseEvent(startEvent) && clickContext) {
                // Use a scoped variable to make sure the value is not changed by other clicks
                var localUserActivity_1 = userActivity;
                var clickEventTimeStamp_1;
                onStartEvent(clickContext, startEvent, function () { return localUserActivity_1; }, function () { return clickEventTimeStamp_1; });
                clickContext = undefined;
                if (isExperimentalFeatureEnabled('dead_click_fixes')) {
                    addEventListener(window, "click" /* CLICK */, function () {
                        clickEventTimeStamp_1 = timeStampNow();
                    }, { capture: true, once: true });
                }
            }
        }, { capture: true }),
        addEventListener(window, "input" /* INPUT */, function () {
            userActivity.input = true;
        }, { capture: true }),
    ];
    return {
        stop: function () {
            listeners.forEach(function (listener) { return listener.stop(); });
        },
    };
}
function isSelectionEmpty() {
    var selection = window.getSelection();
    return !selection || selection.isCollapsed;
}
function isValidMouseEvent(event) {
    return (event.target instanceof Element &&
        // Only consider 'primary' pointer events for now. Multi-touch support could be implemented in
        // the future.
        // On Chrome, click events are PointerEvent with `isPrimary = false`, but we should still
        // consider them valid. This could be removed when we enable the `click-action-on-pointerup`
        // flag, since we won't rely on click events anymore.
        (event.type === 'click' || event.isPrimary !== false));
}
//# sourceMappingURL=listenActionEvents.js.map